// import realEstateGalleryTemplate from './real-estate-gallery.pug';
import angular from 'angular';
import $ from 'jquery';

export const RealEstateGalleryComponent = {
	bindings: {
		realEstateImages: '<',
		onShowFullScreen: '&',
		webWalkClick: '&',
		comissionId: '<'
	},
	templateUrl: 'real-estate-gallery.html',
	controller: class RealEstateGalleryComponent {
		constructor($timeout, $scope) {
			'ngInject';
			this.$timeout = $timeout;
			this.$scope = $scope;
			this.currentSlide = 0;
		}

		$onChanges(changes) {
			if (changes.realEstateImages) {
				this.images = angular.copy(this.realEstateImages);
			}
		}

		$onInit() {
			let vm = this;
			this.setWatcher();
			this.$timeout(function () {
				angular.element('#m19-main-gallery').slick('refresh');
				vm.initSlider();
			}, 3000);
		}

		initSlider() {
			let vm = this;
			if (angular.element('#m19-main-gallery').length) {
				vm.lazyBgImg(true, vm.images.length - 1);
				vm.lazyBgImg(true, 0);
				vm.lazyBgImg(true, 1);
				angular.element('#m19-main-gallery').on('afterChange', (event, slick, slide) => {
					vm.currentSlide = slide;
				});
				angular.element('#m19-main-gallery').on('beforeChange', (event, slick, slide, nextSlide) => {
					if (slide != nextSlide) {
						vm.lazyBgImg(angular.element(slick.$slides.get(nextSlide - 1)), nextSlide - 1);
						vm.lazyBgImg(angular.element(slick.$slides.get(nextSlide)), nextSlide);
						vm.lazyBgImg(angular.element(slick.$slides.get(nextSlide + 1)), nextSlide + 1);
					}
				});
				angular.element('#m19-main-gallery').on('init', (event, slick) => {
					vm.lazyBgImg(angular.element(slick.$slides.get(vm.images.length - 1)), vm.images.length - 1);
					vm.lazyBgImg(angular.element(slick.$slides.get(0)), 0);
					vm.lazyBgImg(angular.element(slick.$slides.get(1)), 1);
				});
			} else {
				vm.$timeout(() => {
					vm.initSlider();
				}, 300);
			}

		}

		lazyBgImg(element, nextSlide) {
			let vm = this;
			if (element) {
				let lazyBgImgs = angular.element('.lazy-bg-img_' + nextSlide);
				$.each(lazyBgImgs, function (index, el) {
					$(el).css('background-image', 'url(' + vm.images[nextSlide].url + ')');
				});
			}
		}

		slideClick() {
			this.onShowFullScreen({
				$event: {
					currentSlide: this.currentSlide
				}
			});
		}

		goToWebWalk($event) {
			this.webWalkClick({ $event });
		}

		setWatcher() {
			this.$scope.$watch('$ctrl.images.length', (newValue) => {
				if (newValue) {
					this.$timeout(() => {
						angular.element('.m19-real-estate-gallery-container .slick-prev').on('click', () => {
							window.dataLayer.push({
								event: 'pageInit',
								pageType: 'Ingatlan végoldal',
								propertyID: this.comissionId
							});
						});
						angular.element('.m19-real-estate-gallery-container .slick-next').on('click', () => {
							window.dataLayer.push({
								event: 'pageInit',
								pageType: 'Ingatlan végoldal',
								propertyID: this.comissionId
							});
						});
					}, 500);
				}
			});
		}
	}
};
